import styled from 'styled-components'

export const NewTemplateActionCardBehavior = styled.div`
  div:first-child{
    cursor: pointer;
  }
`
